// import request from '@/utils/request'
import audioRequest from '@/utils/audioRequest'
import { getToken } from '@/utils/auth'
import store from '@/store'

export function getClientCourseIdList (id) {
  return audioRequest({
    method: 'GET',
    // url: `/ear/public/api/mobile/v2/clients/${id}`
    url: `/ear/public/api/web/v1/clients/${id}`
  })
}

export function getClientAudioList (id) {
  const params = {
    per_page: 10000
  }
  return audioRequest({
    method: 'GET',
    url: `/ear/public/api/web/v1/channels/${id}/players`,
    params
  })
}

export function getAudioUrl (id, isFree) {
  let bearerToken
  if (isFree !== true) {
    const cid = store.state.toB.cid
    const token = getToken(cid)
    bearerToken = {
      Authorization: `Bearer ${token}`
    }
  }
  return audioRequest({
    method: 'GET',
    url: `/ear/public/api/web/v1/episodes/${id}/media_tob`,
    // url: `/ear/public/api/mobile/v1/episodes/${id}/media_tob`,
    headers: isFree ? '' : bearerToken
  })
}



// WEBPACK FOOTER //
// ./src/api/audio.js